import { render, staticRenderFns } from "./InplayList2.vue?vue&type=template&id=16ea94e5&scoped=true"
import script from "./InplayList2.vue?vue&type=script&lang=js"
export * from "./InplayList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ea94e5",
  null
  
)

export default component.exports